export default __webpack_public_path__ + "images/AB.9182b6c.png";